<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Jean-Paul Sartre: To Freedom Condemned</span></p>
<p class="subtitle"><span>A Guide to His Philosophy</span></p>
<p class="authorname"><span>Justus Streller</span></p>
<p class="authorname1"><span>Translated with an introduction by<br/>Wade Baskin</span></p>
<p class="publisher"><span>Philosophical Library</span></p>
<p class="publisher1"><span><img alt="image" src="images/pub.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?19e12dc4